import connectClearRefinements from "instantsearch.js/es/connectors/clear-refinements/connectClearRefinements.js";
import { useConnector } from "../hooks/useConnector.js";
export function useClearRefinements(props, additionalWidgetProperties) {
  return useConnector(connectClearRefinements, props, additionalWidgetProperties);
}